import React, { useEffect, useState } from "react";
import Tab from "../tab/Tab";
import "./ask.css";

import { publicApiClient } from "../../../api/apiClient";

const CONTACT_API = "/api/contact/site";

const getContactData = (result) => {
  return result?.data || result || {};
};

const makeMailLink = (email) => {
  if (!email) return "";
  return email.startsWith("mailto:") ? email : `mailto:${email}`;
};

export default function Ask() {
  const [contact, setContact] = useState({
    contactInfo: "",
    homepageUrl: "",
    email: "",
    partnerEmail: "",
    kakaoUrl: "",
    instagramUrl: "",
    youtubeUrl: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        setIsLoading(true);

        const result = await publicApiClient(CONTACT_API);
        const data = getContactData(result);

        console.log("소통창구 조회 성공:", data);

        setContact({
          contactInfo: data.contactInfo || "",
          homepageUrl: data.homepageUrl || "",
          email: data.email || "",
          partnerEmail: data.partnerEmail || "",
          kakaoUrl: data.kakaoUrl || "",
          instagramUrl: data.instagramUrl || "",
          youtubeUrl: data.youtubeUrl || "",
        });
      } catch (error) {
        console.error("소통창구 조회 실패:", error);

        setContact({
          contactInfo: "",
          homepageUrl: "",
          email: "",
          partnerEmail: "",
          kakaoUrl: "",
          instagramUrl: "",
          youtubeUrl: "",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchContact();
  }, []);

  return (
    <>
      <Tab />

      <section className="ask-container">
        <h2 className="ask-title">소통창구</h2>
        <br />

        <p className="ask-text">
          {isLoading ? (
            "소통창구 정보를 불러오는 중입니다."
          ) : contact.contactInfo ? (
            contact.contactInfo.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))
          ) : (
            ""
          )}
        </p>

        <div className="ask-icons">
          {/* 총학생회 홈페이지 링크 */}
          {contact.homepageUrl && (
            <a
              href={contact.homepageUrl}
              className="ask-icon-item"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="총학생회 홈페이지"
            >
              <div className="ask-icon ask-icon-site"></div>
            </a>
          )}

          {/* 총학생회 이메일 */}
          {contact.email && (
            <a
              href={makeMailLink(contact.email)}
              className="ask-icon-item"
              aria-label="총학생회 이메일"
            >
              <div className="ask-icon ask-icon-email"></div>
            </a>
          )}

          {/* 협력 이메일 */}
          {contact.partnerEmail && (
            <a
              href={makeMailLink(contact.partnerEmail)}
              className="ask-icon-item"
              aria-label="협력 이메일"
            >
              <div className="ask-icon ask-icon-univmail"></div>
            </a>
          )}

          {/* 카카오톡 채널 링크 */}
          {contact.kakaoUrl && (
            <a
              href={contact.kakaoUrl}
              className="ask-icon-item"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="카카오톡 채널"
            >
              <div className="ask-icon ask-icon-kakao"></div>
            </a>
          )}

          {/* 인스타그램 링크 */}
          {contact.instagramUrl && (
            <a
              href={contact.instagramUrl}
              className="ask-icon-item"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="인스타그램"
            >
              <div className="ask-icon ask-icon-instagram"></div>
            </a>
          )}

          {/* 유튜브 링크 */}
          {contact.youtubeUrl && (
            <a
              href={contact.youtubeUrl}
              className="ask-icon-item"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="유튜브"
            >
              <div className="ask-icon ask-icon-youtube"></div>
            </a>
          )}
        </div>
      </section>
    </>
  );
}